"use client";

import { type ReactNode } from "react";

import { Cards } from "~/components/cards";
import { TourCard, type Tour } from "~/components/tour-card";
import { type RouterOutputs } from "~/trpc/types";

export function TourCards({
  title,
  tours,
}: {
  title: ReactNode;
  tours: {
    inventory?: Pick<
      RouterOutputs["inventory"]["search"]["results"][0],
      "amount" | "perPerson" | "locationName"
    >;
    tour: Tour;
  }[];
}) {
  return (
    <Cards
      items={tours.map(({ tour, inventory }) => ({
        tour,
        inventory,
        id: tour.id,
      }))}
      title={title}
      CardComponent={TourCard}
    />
  );
}
